// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconDeliveryPath = 'M15.002 18H5v-4h10l.002 4ZM10 2c2.599 0 4.817 1.474 5.64 3.505-1.871-.563-4.026-.329-5.64.683-1.615-1.012-3.769-1.244-5.639-.686C5.186 3.473 7.402 2 10 2Zm-1 9.423L4.824 7.46c1.372-.451 2.994-.278 4.176.483v3.48Zm2-3.48c1.18-.76 2.8-.935 4.174-.48L11 11.423v-3.48Zm7-.406-.008-.44C17.923 3.184 14.339 0 10 0S2.077 3.184 2.008 7.097L2 7.537 6.705 12H3v6c0 1.103.898 2 2 2h10c1.103 0 2-.897 2-2v-6h-3.705L18 7.537Z';
var IconDelivery = baseIcon('IconDelivery', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconDeliveryPath
});
export default IconDelivery;
//# sourceMappingURL=index.js.map